import { uploadData } from "aws-amplify/storage";
import { Amplify } from "aws-amplify";
//import forge from "node-forge";
import config from "../config";
import { splitFileName } from "./fileName";
//import { createSingleFileVectorStore } from "./api/CandooAI/apis/AiQuery";

const { AssetsURL, AssetsBucket } = config;

// const calculateHash = async (file) => {
//   try {
//     const CHUNK_SIZE = 1024 * 1024; // 1MB chunks
//     const fileSize = file.size;
//     let offset = 0;
//     const md = forge.md.sha256.create();

//     const hashBufferPromise = new Promise((resolve, reject) => {
//       const processChunk = async () => {
//         try {
//           const chunk = file.slice(offset, offset + CHUNK_SIZE);
//           const chunkArrayBuffer = await chunk.arrayBuffer();
//           const chunkArray = new Uint8Array(chunkArrayBuffer);

//           md.update(chunkArray);

//           offset += chunkArray.length;

//           if (offset < fileSize) {
//             processChunk();
//           } else {
//             resolve(md.digest().toHex());
//           }
//         } catch (error) {
//           reject(error);
//         }
//       };

//       processChunk();
//     });

//     const hashHex = await hashBufferPromise;

//     return hashHex;
//   } catch (error) {
//     throw new Error(`Error calculating hash: ${error.message}`);
//   }
// };

export default async function uploadPDF(file, folder, id) {
  Amplify.configure({
    ...Amplify.getConfig(),
    Storage: {
      S3: {
        region: process.env.REACT_APP_REGION,
        bucket: AssetsBucket,
      },
    },
  });

  // The output is always .pdf, so only the sanitised base is needed. This
  // replaces a `.split(".pdf")[0]`, which was case-sensitive and matched
  // mid-name: "REPORT.PDF" kept its extension inside the key and
  // "notes.v2.pdf" lost a segment.
  const { base } = splitFileName(file.name);
  const fileName = `${base}-${id}.pdf`;
  const pdfKey = `${folder}/${fileName}`;

  await uploadData({
    path: pdfKey,
    data: file,
    options: {
      contentType: file.type,
    },
  });

  const url = `${AssetsURL}/${pdfKey}`;

  return [url, pdfKey];

  // Code for creating a vector store with CandooAI
  // Commented out because CandooAI apis are not maintained and is causing errors when uploading a pdf
  // if (stage === "dev") {
  //   const hashKey = await calculateHash(file);
  //   const pureFileName = file.name.split(".pdf")[0];
  //   const fileName = `${pureFileName}-${id}.pdf`;
  //   const pdfKey = `${folder}/${fileName}`;

  //   await uploadData({
  //     path: pdfKey,
  //     data: file,
  //       options: {
  //         contentType: file.type,
  //       }
  //    });

  //   const vectorStoreFileName = `Nualang-${fileName}`;
  //   const body = {
  //     resourceUrls: [
  //       {
  //         fileName: vectorStoreFileName,
  //         key: pdfKey,
  //         hashKey,
  //       },
  //     ],
  //     source: "nualang",
  //   };

  //   const createVectorStore = await createSingleFileVectorStore(body);

  //   const pdfVectorStoreCreationStatus =
  //     createVectorStore && createVectorStore.statusCode === 200
  //       ? "CREATION_COMPLETE"
  //       : "CREATION_FAILED";

  //   const url = `${AssetsURL}/${pdfKey}`;

  //   return [
  //     url,
  //     pdfKey,
  //     vectorStoreFileName,
  //     hashKey,
  //     pdfVectorStoreCreationStatus,
  //   ];
  // }
}
